import { gql } from "graphql-request";
import MainPhotoFragment from "queries/fragments/MainPhoto";
import SectionHeader from "queries/fragments/SectionHeader";
import RichText from "queries/fragments/RichText";
import AttractionCard from "queries/fragments/AttractionCard";

const PARK_QUERY = gql`
  ${MainPhotoFragment}
  ${SectionHeader}
  ${RichText}
  ${AttractionCard}

  query Park($slug: String!) {
    parks(where: { Slug: $slug }) {
      __typename
      id
      Name
      Slug
      OpeningDate
      ClosedDate
      CurrentlyOperating
      IsTempClosed
      Type
      Companies {
        id
        Name
        Slug
      }
      Resort {
        id
        Name
        Slug
      }
      Attractions {
        ...AttractionCard
      }
      CoverPhoto {
        ...MainPhoto
      }
      MainPhoto {
        ...MainPhoto
      }
      Lands {
        __typename
        Name
        Content
        Attractions {
          ...AttractionCard
        }
      }
      Sections {
        ...SectionHeader
        ...RichText
      }
      SeasonalEvent {
        id
        Name
        Description
        StartDate
        EndDate
      }
      Location {
        Latitude
        Longitude
      }
    }
  }
`;

export default PARK_QUERY;
